import type { ProjectsList } from '../../common/types.tsx';

export const getTotalPages = (data: ProjectsList, pageSize: number): number => {
	if (!data || !data.total) {
		return 1;
	}

	const totalPages: number = Math.ceil(data.total / pageSize);
	return totalPages;
};

// returns array of labels to be used for pagination component
export const getPageLabels = (totalPages: number): number[] => {
	if (totalPages <= 0) return [];
	return [...Array(totalPages)].map((_, index: number): number => index + 1);
};
